import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const faceOfInterestModeIcon = createIconDefinition(
  'faceOfInterestMode',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.25464 2.68069C9.72386 2.43977 10.2761 2.43977 10.7454 2.68069L16.5787 5.67593C17.1433 5.96585 17.5 6.5585 17.5 7.20679V12.7932C17.5 13.4415 17.1433 14.0342 16.5787 14.3241L10.7454 17.3193C10.2761 17.5602 9.72386 17.5602 9.25464 17.3193L3.42131 14.3241C2.85667 14.0341 2.5 13.4415 2.5 12.7932V7.20679C2.5 6.5585 2.85667 5.96585 3.42131 5.67593L9.25464 2.68069ZM10.8333 15.3605V10.5289L15.8333 7.96156V12.7932L10.8333 15.3605ZM10 9.04321L14.7049 6.62738L10 4.21156L5.29508 6.62738L10 9.04321Z" fill="#232426" fill-opacity="0.6"/>
</svg>
`,
);
